<template>
  <el-select
    v-model="dataValue"
    style="width: 200px;"
    placeholder="请选择实验室"
    @change="onChage">
    <el-option
      v-for="item in list"
      :key="item.labId"
      :label="item.labName"
      :value="item.labId"
    >
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'LabSelect',
  props: ['value', 'callback'],
  data() {
    return {
      list: []
    }
  },
  computed: {
    dataValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    onChage() {
      this.callback && this.callback()
    },
    getList() {
      this.$store.dispatch('account/getlabs', {
        payload: {},
        success: (res) => {
          this.list = res.data.records
        },
        fail: () => {
          this.list = []
        }
      })
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" type="text/stylus" scoped></style>
